// extracted by mini-css-extract-plugin
module.exports = {"RichText":"RichText_RichText__J7Iji","RichText___center":"RichText_RichText___center__cncnc"};